import { render, staticRenderFns } from "./ReceiptInsertDialog.vue?vue&type=template&id=4c245492&scoped=true&"
import script from "./ReceiptInsertDialog.vue?vue&type=script&lang=js&"
export * from "./ReceiptInsertDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInsertDialog.vue?vue&type=style&index=0&id=4c245492&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c245492",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VTextField})
